<template>
    <v-card>
        <v-card-title>
            <v-text-field
                v-model.trim="search"
                append-icon="mdi-magnify"
                hide-details
                label="Search"
                single-line
            ></v-text-field>
        </v-card-title>
        <v-data-table
            :custom-filter="customFilter"
            :footer-props="footerProps"
            :headers="headers"
            :items="sensorErrors"
            :items-per-page="20"
            :loading="loading"
            :options.sync="options"
            :page="tableOptions && tableOptions.page ? tableOptions.page : 1"
            :search="search"
            :server-items-length="count"
            class="elevation-1"
            loading-text="Loading station errors"

        >
            <template v-slot:header.status="{  }">
                <v-menu v-model="showStatusMenu" :close-on-content-click="false" offset-y>
                    <template v-slot:activator="{ on }">
                        <span style="cursor: pointer; white-space: nowrap;"
                              v-on="on">{{ `Status (${selectedStatus})` }}</span>
                    </template>
                    <v-card class="px-5 py-2" style="z-index: 10">
                        <v-row>
                            <v-radio-group v-model="selectedStatus">
                                <v-radio
                                    v-for="status in statuses"
                                    :key="status"
                                    :label="`${status.charAt(0).toUpperCase() + status.slice(1)}`"
                                    :value="status"
                                    @click="handleFilterStatusesClick(); showStatusMenu = false">
                                    >
                                </v-radio>
                            </v-radio-group>
                        </v-row>
                    </v-card>
                </v-menu>
            </template>
            <template v-slot:item.status="{ item }">
                <v-chip :class="item.status === 'error' ? 'error' : item.status === 'warning' ? 'warning' : 'unset'">
                    {{ item.status | cleanString }}
                </v-chip>
            </template>
            <template v-slot:item.start_date="{ item }">
                <span>{{ parseDate(item.start_date) }}</span>
            </template>
            <template v-slot:item.name="{ item }">
                <router-link :to="{name: 'station-view', params: {id: item.station_id}}" >{{ item.name }}</router-link>
            </template>
            <template v-slot:item.show_error_to_user="{ item }">
                <div v-if="item.show_error_checkbox" class="flex align-center justify-center" style="width: 100%; display: flex">
                    <v-checkbox dense
                                hide-details
                                :ripple="false"
                                class="pt-0"
                                v-model="item.show_error_to_user"
                                @change="handleShowErrorToUserCheckboxToggle(item)"
                    />
                </div>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import debounce from 'debounce'
import moment from "moment";

export default {
    name: "StationErrorList",
    data() {
        return {
            search: '',
            options: this.tableOptions,
            footerProps: {"items-per-page-options": [20, 50, 100, 500]},
            statuses: ['all', 'error', 'warning'],
            showStatusMenu: false,
            selectedStatus: 'all',
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                },
                {
                    text: 'Long alias',
                    align: 'start',
                    sortable: false,
                    value: 'long_alias',
                },
                {
                    text: 'Sensor',
                    align: 'start',
                    sortable: false,
                    value: 'sensor_alias',
                },
                {
                    text: 'Status',
                    align: 'center',
                    sortable: false,
                    value: 'status',
                },
                {
                    text: 'Description',
                    align: 'start',
                    sortable: false,
                    value: 'description',
                },
                {
                    text: 'Error type',
                    align: 'start',
                    sortable: false,
                    value: 'error_type',
                },
                {
                    text: 'Start date',
                    align: 'start',
                    sortable: false,
                    value: 'start_date',
                },
                {
                    text: 'Show error to user',
                    align: 'start',
                    sortable: false,
                    value: 'show_error_to_user',
                },
            ],
        }
    },
    watch: {
        async search() {
            await this.setSearchString(this.search);
            this.debouncedSearch(this.search);
        },
        options(val) {
            this.setTableOptions(val);
            this.fetchAllSensorErrors()
        },
    },
    created() {
        this.setQueryStatus(this.selectedStatus);

        this.debouncedSearch = debounce(() => {
            this.setTableOptions({...this.tableOptions, page: 1});
            this.fetchAllSensorErrors()
        }, 300)

        this.fetchAllSensorErrors()
    },
    computed: {
        ...mapState('sensorError', ['sensorErrors', 'loading', 'queryStatus', 'tableOptions', 'sensorErrors', 'count'])
    },
    methods: {
        ...mapActions('sensorError', ['fetchAllSensorErrors', 'setShowErrorToUser']),
        ...mapMutations('sensorError', ['setTableOptions', 'setSearchString', 'setQueryStatus']),
        customFilter(items) {
            return items;
        },
        handleFilterStatusesClick() {
            this.setQueryStatus(this.selectedStatus);
            this.setTableOptions({...this.tableOptions, page: 1});
            this.fetchAllSensorErrors()
        },
        parseDate(date) {
            return moment(date).format('DD-MM-YYYY HH:MM')
        },
        async handleShowErrorToUserCheckboxToggle(item) {
            await this.setShowErrorToUser({probeId: item.station_id, value: item.show_error_to_user})
        }
    }
}
</script>

<style scoped>

.error {
    background: red;
}

.warning {
    background: orange;
}

.unset {
    background: lightgrey;
}

.probe-name {
    cursor: pointer;
}

</style>